export const snackbar = {
    addToCartSuccess: "Varukorgen har uppdaterats.",
};
